import type { Queries } from "~/const/hrefs";
import type { G_GetVideoQuery } from "~/lib/graphql";

type CanonicalDetailUrl = `${string}`;
type OgpDetailUrl = CanonicalDetailUrl | `${CanonicalDetailUrl}&spot=${string}`;
type AiAdDetailBackUrl = CanonicalDetailUrl | `${CanonicalDetailUrl}%26spot=${string}`;

type Args = {
  spot?: Queries["spot"];
  videoData: G_GetVideoQuery["video"];
};

export const buildDetailUrl = (args: Args) => {
  const { spot, videoData } = args;

  const vodDetailPath = videoData.url;

  // &spot=true をクエリパラメータ末尾に付与する
  const ogpDetailUrl: OgpDetailUrl = spot === undefined ? vodDetailPath : `${vodDetailPath}&spot=${spot}`;

  // %26（&をエンコードしたもの）spot=true をクエリパラメータ末尾に付与する
  const aiadDetailBackUrl: AiAdDetailBackUrl = spot === undefined ? vodDetailPath : `${vodDetailPath}%26spot=${spot}`;

  return {
    /** スポット配信の場合は`?season=AAA&spot=true` スポット配信でない場合は`?season=AAA` */
    ogpDetailUrl,
    canonicalDetailUrl: vodDetailPath,
    /** TwitterボタンとLINEボタン押下時に付与するURL */
    aiadDetailBackUrl,
  };
};
